import { Component } from 'react';
import {
    Card,
    CardHeader,
    CardSection,
    Heading,
    Text,
    Collapsible,
    Spacer,
    TextButton,
    StyledLabel,
    spaceMixin,
} from '@zillow/constellation';
import { trackEvent } from '@zillow/universal-analytics';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BulletedCheckList from '../BulletedCheckList';
import TermsModal from './TermsModal';

const StyledLoanTypeCard = styled(Card)`
    position: relative;
    ${StyledLabel}:hover {
        cursor: default;
    }
`;
const StyledTermsContainer = styled.div`
    position: absolute;
    bottom: ${spaceMixin('sm')};
    left: 0;
    text-align: center;
    width: 100%;
`;
const StyledCardSubContent = styled.div`
    & + & {
        margin-top: ${spaceMixin('md')};
    }
`;

class LoanTypeCard extends Component {
    static propTypes = {
        className: PropTypes.string,
        title: PropTypes.string,
        fetchTerms: PropTypes.func,
        terms: PropTypes.string,
        sections: PropTypes.arrayOf(
            PropTypes.shape({
                key: PropTypes.string,
                content: PropTypes.node,
            })
        ),
    };
    state = {
        termsOpen: false,
    };
    toggleTerms = value => {
        this.setState({
            termsOpen: value,
        });
    };
    render() {
        const { termsOpen } = this.state;
        const { title, sections, fetchTerms, terms } = this.props;
        return (
            <StyledLoanTypeCard>
                <Collapsible>
                    {() => (
                        <>
                            <CardHeader>{title}</CardHeader>
                            <CardSection aria-label={title}>
                                <Spacer marginBottom="xl">
                                    {sections.map(section => (
                                        <StyledCardSubContent key={section.key}>{section.content}</StyledCardSubContent>
                                    ))}
                                </Spacer>
                                <StyledTermsContainer>
                                    <TextButton
                                        onClick={() => {
                                            if (terms) {
                                                this.toggleTerms(true);
                                            } else {
                                                fetchTerms().then(() => {
                                                    this.toggleTerms(true);
                                                });
                                            }
                                            trackEvent({
                                                category: 'Mortgages',
                                                action: `Loan terms viewed - ${title}`,
                                            });
                                        }}>
                                        See sample loan terms
                                    </TextButton>
                                </StyledTermsContainer>
                                <TermsModal onClose={() => this.toggleTerms(false)} isOpen={termsOpen} terms={terms} />
                            </CardSection>
                        </>
                    )}
                </Collapsible>
            </StyledLoanTypeCard>
        );
    }
}
const StyledDownPayment = styled.div`
    text-align: center;
`;
const StyledCardContent = styled.div``;
const ExplicitLoanTypeCard = ({ description, downPayment, points, ...props }) => (
    <LoanTypeCard
        {...props}
        sections={[
            {
                key: 'downPayment',
                content: (
                    <StyledDownPayment>
                        <Text fontType="bodySmall">{description}</Text>
                        <Spacer marginTop="sm">
                            <Heading level="3">{downPayment}</Heading>
                            <Text fontType="bodySmall">min. down payment</Text>
                        </Spacer>
                    </StyledDownPayment>
                ),
            },
            {
                key: 'sellingPoints',
                content: (
                    <StyledCardContent>
                        <Heading level={6} fontType="bodySmallHeading">
                            Loan highlights
                        </Heading>
                        <Spacer marginTop="xs">
                            <BulletedCheckList items={points} fontType="bodySmall" />
                        </Spacer>
                    </StyledCardContent>
                ),
            },
        ]}
    />
);
ExplicitLoanTypeCard.propTypes = {
    fetchTerms: PropTypes.func,
    className: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    downPayment: PropTypes.string,
    terms: PropTypes.string,
    points: PropTypes.arrayOf(PropTypes.string),
};
export { ExplicitLoanTypeCard, StyledLoanTypeCard };
export default LoanTypeCard;
